import { NgModule } from '@angular/core';

import { MomentPipe } from './momentPipe.pipe';
import { DateFormatPipe } from './dateFormat.pipe';

export { MomentPipe } from './momentPipe.pipe';
export { DateFormatPipe } from './dateFormat.pipe';

const pipes = [
    MomentPipe, DateFormatPipe
];

@NgModule({
    declarations: [
        pipes
    ],
    exports: [pipes],
    providers: [pipes]
})
export class PipesModule { }
